// Closing Entry Mutations

export const setClosingEntryList = (state, payload) => {
  state.closingEntryList = payload
}

export const setClosingEntry = (state, payload) => {
  state.closingEntry = payload
}
